<template>
	<span ref="el"></span>
</template>
<script>
import CountUp from 'countup.js'
export default{
  name: 'CountUp',
  props: {
    'ids': {},
    'number': {
      default: 0
    },
    precision: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: '.',
        suffix: ''
      }
    }
  },
  methods: {
    changeCount () {
      new CountUp(this.$refs.el, 0, this.number, this.precision, 2.5, this.options).start()
    }
  },
  mounted () {
    this.changeCount()
  },
  watch: {
    number: function () {
      this.changeCount()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/count/index.vue